import React, { createContext, useContext, ReactNode } from "react";
import { Howl } from "howler";

const SoundContext = createContext<{
  play: (type: "success" | "error") => void;
}>({
  play: () => {},
});

interface SoundProviderProps {
  children: ReactNode;
}

export const useSoundContext = () => {
  return useContext(SoundContext);
};

export const SoundProvider: React.FC<SoundProviderProps> = ({ children }) => {
  const play = (type: "success" | "error") => {
    let sound: Howl;

    if (type === "success") {
      sound = new Howl({
        src: ["/assets/code-correct.wav"],
        volume: 1,
      });
    } else {
      sound = new Howl({
        src: ["/assets/code-wrong.wav"],
        volume: 1,
      });
    }

    sound.play();
  };

  return (
    <SoundContext.Provider value={{ play }}>{children}</SoundContext.Provider>
  );
};
